import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  max-width: 500px;
  flex-direction: column;
`;
